import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Label } from '../../../components/ui/label';
import { CheckCircle, XCircle } from 'lucide-react';

const ApprovalTab = ({
  pendingMarkets,
  approveMarket
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CheckCircle className="h-5 w-5" />
          Pending Market Approvals
        </CardTitle>
        <CardDescription>
          Review and approve markets created by creators
        </CardDescription>
      </CardHeader>
      <CardContent>
        {pendingMarkets.length === 0 ? (
          <div className="text-center py-8">
            <CheckCircle className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">No pending market approvals</p>
          </div>
        ) : (
          <div className="space-y-6">
            {pendingMarkets.map((market) => (
              <Card key={market.id} className="border">
                <CardHeader>
                  <div className="flex justify-between items-start">
                    <div>
                      <CardTitle className="text-lg">{market.title}</CardTitle>
                      <CardDescription>
                        Created by: {market.creator?.handle || 'Unknown Creator'}
                      </CardDescription>
                    </div>
                    <Badge variant="secondary">Pending Approval</Badge>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <div>
                      <Label className="font-medium">Description:</Label>
                      <p className="text-sm text-gray-600 mt-1 dark:text-gray-400">
                        {market.description}
                      </p>
                    </div>
                    
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div>
                        <Label className="font-medium">Category:</Label>
                        <p className="text-sm text-gray-600 dark:text-gray-400">{market.category}</p>
                      </div>
                      <div>
                        <Label className="font-medium">Closes At:</Label>
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                          {new Date(market.closes_at).toLocaleDateString()}
                        </p>
                      </div>
                      <div>
                        <Label className="font-medium">Resolution Source:</Label>
                        <p className="text-sm text-gray-600 dark:text-gray-400">{market.resolution_source}</p>
                      </div>
                    </div>
                    
                    {market.slug && (
                      <div>
                        <Label className="font-medium">Slug (Future URL):</Label>
                        <code className="block text-sm bg-gray-100 p-2 rounded mt-1 dark:bg-slate-800">
                          predfuture.com/m/{market.slug}
                        </code>
                      </div>
                    )}
                    
                    <div className="text-xs text-gray-500 dark:text-gray-400">
                      Created: {new Date(market.created_at).toLocaleDateString()}
                    </div>
                    
                    <div className="flex gap-2 pt-4 border-t">
                      <Button 
                        onClick={() => approveMarket(market.id, 'approved')}
                        className="flex-1"
                      >
                        <CheckCircle className="h-4 w-4 mr-2" />
                        Approve Market
                      </Button>
                      <Button 
                        variant="destructive"
                        onClick={() => {
                          const reason = prompt('Rejection reason (optional):');
                          approveMarket(market.id, 'rejected', reason);
                        }}
                        className="flex-1"
                      >
                        <XCircle className="h-4 w-4 mr-2" />
                        Reject Market
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ApprovalTab;
